import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-expand",
  "use": "foquz-icon-expand-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" id=\"foquz-icon-expand\"><path d=\"M4 1H1m0 0v3m0-3l4 4m5-4h3m0 0v3m0-3L9 5m-5 8H1m0 0v-3m0 3l4-4m5 4h3m0 0v-3m0 3L9 9\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol